import { CascadiaColor } from "@certn/cascadia-tokens";

export type AvatarSize = "x-small" | "small" | "medium" | "large" | "x-large";

export type AvatarType = "image" | "text" | "icon" | "logo";

export type AvatarGroupType = "group" | "compact";

export const BaseColors = [
  "tofino",
  "blue",
  "green",
  "purple",
  "red",
  "orange",
] as const;

export type AvatarColors = "neutral" | (typeof BaseColors)[number];

export interface AvatarSizeValues {
  width: string;
  height: string;
  fontSize: string;
}

export interface AvatarSharedProps {
  children?: React.ReactNode;
  size?: AvatarSize;
  backgroundColor?: CascadiaColor;
  fontColor?: CascadiaColor;
  testID?: string;
  displayVerifiedBadge?: boolean;
  className?: string;
}

export const avatarSizes = {
  "x-small": {
    width: "space-6",
    height: "space-6",
    fontSize: "font-size-50",
  },
  small: {
    width: "space-8",
    height: "space-8",
    fontSize: "font-size-50",
  },
  medium: {
    width: "space-10",
    height: "space-10",
    fontSize: "font-size-75",
  },
  large: {
    width: "space-12",
    height: "space-12",
    fontSize: "font-size-100",
  },
  "x-large": {
    width: "space-16",
    height: "space-16",
    fontSize: "font-size-200",
  },
} as const;
